<div class="recherche-photo-artiste">
  <form class="search-form">
    <mat-form-field class="search-full-width">
      <mat-label>Recherche photo artiste</mat-label>
      <input #searchInput matInput placeholder="Recherche photo artiste" value="" (keydown.enter)="searchArtistPictureEnter($event, searchInput.value)" >
      <button mat-button *ngIf="searchInput.value" matSuffix aria-label="Clear" (click)="searchInput.value=''">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-form-field>
  </form>
  <button color="primary" class="search-full-width-button" mat-flat-button (click)="searchArtistPicture(searchInput.value)">Recherche</button>
</div>

<div class="searchResults">
  <mat-progress-spinner *ngIf="loading" class="mat-progress-spinner-coverSearch" mode="indeterminate"></mat-progress-spinner>

  <div style="text-align: center">
    <img *ngFor="let deezerArtistPictureResult of deezerArtistPictureResults" [src]="deezerArtistPictureResult.picture_medium"
         style="margin: 10px; cursor: pointer; max-width: 250px; max-height: 200px;"
         (click)="selectCover(deezerArtistPictureResult.picture_xl)"
         matTooltip="{{ deezerArtistPictureResult.name }} (Deezer)" matTooltipPosition="above" />
  </div>

  <div style="text-align: center">
    <img *ngFor="let spotifyArtistPictureResult of spotifyArtistPictureResults" [src]="spotifyArtistPictureResult.images[1].url"
         style="margin: 10px; cursor: pointer; max-width: 250px; max-height: 200px;"
         (click)="selectCover(spotifyArtistPictureResult.images[0].url)"
         matTooltip="{{ spotifyArtistPictureResult.name }} (Spotify)" matTooltipPosition="above" />
  </div>

  <div style="text-align: center">
    <img *ngFor="let discogsArtistPictureResult of discogsArtistPictureResults" [src]="discogsArtistPictureResult.cover_image"
         style="margin: 10px; cursor: pointer; max-width: 250px; max-height: 200px;"
         (click)="selectCover(discogsArtistPictureResult.cover_image)"
         matTooltip="{{ discogsArtistPictureResult.title }} (Discogs)" matTooltipPosition="above" />
  </div>
</div>
